<template>
  <div class="modal" v-if="show">
    <div class="modal-content">
      <div class="modal-body">
        <p>Вы хотите перенести запись?</p>
      </div>
      <div class="modal-footer">
        <a
          :style="{backgroundColor: primaryColor}"
          class="btn"
          :href="url"
          target="_blank"
          @click="show = false"
        >Да</a>
        <a
          :style="{backgroundColor: secondaryColor}"
          class="btn"
          @click="show = false"
        >Нет</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean,
    primaryColor: String,
    secondaryColor: String,
    url: String
  },
  computed: {
    show: {
      get () { return this.value },
      set (value) { this.$emit('input', value) }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  position: fixed;
  z-index: 5;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(255,255,255,0.97);
}
.modal-content {
  position: relative;
  margin: auto;
  padding: 0;
  width: 80%;
}
.modal-body p {
  text-align: center;
}
.modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.btn {
  font-size: 1em;
  margin: 0.625em;
  flex: 1;
  align-items: flex-start;
  text-align: center;
  color: white;
  outline: 0;
  border: 0;
  padding: 0.875em 1.25em;
  -webkit-transition-duration: 0.4s;
  transition-duration: 0.4s;
  overflow: hidden;
  position: relative;
}
.btn:after {
  content: '';
  background: white;
  display: block;
  position: absolute;
  padding-top: 300%;
  padding-left: 350%;
  margin-left: -20px !important;
  margin-top: -120%;
  opacity: 0;
  transition: all 0.8s;
}
.btn:active:after {
  padding: 0;
  margin: 0;
  opacity: 1;
  transition: 0s;
}
a:link, a:visited, a:hover, a:active {
  text-decoration: none;
}
</style>
